export default () => {
    const header = document.querySelector("header");
    const sentinal = document.querySelector("header .sentinal");
    const logo = document.querySelector(".primary-nav__brand-logo img");
    const navCTAs = document.querySelectorAll(".primary-nav .nav-cta");
    const host = window.location.host;

    // configure the intersection observer instance
    const intersectionObserverConfig = {
        rootMargin: "30px 0px 0px 0px",
        ratio: 0,
    };

    function onIntersection(entries) {
        entries.forEach((entry) => {
            const { isIntersecting, intersectionRatio } = entry;
            if (isIntersecting || intersectionRatio > 0) {
                header.classList.remove("sticky");
                navCTAs.forEach((navCTA) => {
                    navCTA.classList.remove("btn");
                    navCTA.classList.remove("btn--secondary");
                });
                logo.setAttribute(
                    "src",
                    `/images/lupkynis-logo.png`
                );
                logo.setAttribute(
                    "srcset",
                    `/images/lupkynis-logo.png 1x, /images/lupkynis-logo@2x.png 2x`
                );
            } else if (!isIntersecting || intersectionRatio === 0) {
                header.classList.add("sticky");
                if (window.matchMedia("(min-width: 992px)").matches) {
                    navCTAs.forEach((navCTA) => {
                        navCTA.classList.add("btn");
                        navCTA.classList.add("btn--secondary");
                    });

                    logo.setAttribute(
                        "src",
                        `/images/lupkynis-icon.png`
                    );
                    logo.setAttribute(
                        "srcset",
                        `/images/lupkynis-icon.png 1x, /images/lupkynis-icon@2x.png 2x`
                    );
                }
            }
        });
    }

    // create observer instance
    const observer = new IntersectionObserver(
        onIntersection,
        intersectionObserverConfig
    );

  // REMOVE INTERSECTION OBSERVER FOR SCREENSHOTS
  const isEDMode = window.location.href.indexOf("ed=1") > 1;
  if (!Evoke.screenshooting() && header && sentinal && !isEDMode) {
    // provide the observer with a target
    observer.observe(sentinal);
  }
};
